import { MapWithDefault } from '@app-shared/functions/helpers.functions';

/**
 * Shortage status ENUM that maps status IDs
 */
export enum ShortageStatus {
  Available = 1,
  Shortage = 2,
  BackInStock = 3,
  OutOfTrade = 4,
  AvailableAtWholesaler = 5,
  PreferableThroughWholesaler = 6,
  Limited = 7,
  Pruning = 8,
  OutOfMarket = 9,
  ExpectedStockOut = 10,
}

export enum ShortageStatusNames {
  Available = 'PRODUCT.SHORTAGE.STATUS.AVAILABLE',
  Shortage = 'PRODUCT.SHORTAGE.STATUS.SHORTAGE',
  BackInStock = 'PRODUCT.SHORTAGE.STATUS.BACK_IN_STOCK',
  OutOfTrade = 'PRODUCT.SHORTAGE.STATUS.OUT_OF_TRADE',
  AvailableAtWholesaler = 'PRODUCT.SHORTAGE.STATUS.AVAILABLE_AT_WHOLESALER',
  PreferableThroughWholesaler = 'PRODUCT.SHORTAGE.STATUS.PREFERABLE_THROUGH_WHOLESALER',
  Limited = 'PRODUCT.SHORTAGE.STATUS.LIMITED',
  Pruning = 'PRODUCT.SHORTAGE.STATUS.PRUNING',
  OutOfMarket = 'PRODUCT.SHORTAGE.STATUS.OUT_OF_MARKET',
  ExpectedStockOut = 'PRODUCT.SHORTAGE.STATUS.EXPECTED_STOCK_OUT',
}

/**
 * Map of translation keys for the availability filters
 */
export const shortageStatusNamesMap = new MapWithDefault<
  ShortageStatus,
  string
>('', [
  [ShortageStatus.Available, ShortageStatusNames.Available],
  [ShortageStatus.Shortage, ShortageStatusNames.Shortage],
  [ShortageStatus.BackInStock, ShortageStatusNames.BackInStock],
  [ShortageStatus.OutOfTrade, ShortageStatusNames.OutOfTrade],
  [
    ShortageStatus.AvailableAtWholesaler,
    ShortageStatusNames.AvailableAtWholesaler,
  ],
  [
    ShortageStatus.PreferableThroughWholesaler,
    ShortageStatusNames.PreferableThroughWholesaler,
  ],
  [ShortageStatus.Limited, ShortageStatusNames.Limited],
  [ShortageStatus.Pruning, ShortageStatusNames.Pruning],
  [ShortageStatus.OutOfMarket, ShortageStatusNames.OutOfMarket],
  [ShortageStatus.ExpectedStockOut, ShortageStatusNames.ExpectedStockOut],
]);
